import Swiper from "swiper/bundle";
import "swiper/css";
import "swiper/css/effect-fade";
import "swiper/css/zoom";

window.addEventListener("DOMContentLoaded", () => {
  // .p-experience-detail__slider があるかチェック
  if (document.querySelector(".p-experience-detail__slider")) {
    // サムネイルのスライダー
    const thumbnail = new Swiper(".thumbnail", {
      freeMode: true,
      slidesPerView: 5,
      spaceBetween: 10,
      watchSlidesVisibility: true,
      watchSlidesProgress: true,
    });

    // メインのスライダー
    const slider = new Swiper(".slider", {
      loop: true,
      navigation: {
        nextEl: ".swiper-button-next",
        prevEl: ".swiper-button-prev",
      },
      thumbs: {
        swiper: thumbnail,
      },
    });
  }
});